import { FAQ } from '@/types/faq.types';
import drivesourceFaqs from './faqs.drivesource.json';
import homesourceFaqs from './faqs.homesource.json';

export const getFAQs = (): FAQ[] => {
    const displayName = import.meta.env.VITE_ASSISTANT_DISPLAY_NAME;

    switch (displayName) {
        case 'DriveSource':
            return drivesourceFaqs as FAQ[];
        case 'HomeSource':
            return homesourceFaqs as FAQ[];
        default:
            return [];
    }
};

export const getFAQByPath = (path: string): FAQ | undefined => {
    const faqs = getFAQs();
    return faqs.find(faq => faq.path === path);
};
